import { getDeviationUrl } from '../DeviationViews/_helpers';
import MediaService from '../utils/DeviationMediaService';
export function getDeviationShareCodes(deviation) {
    var preview = MediaService.getDeviationFile(deviation, 'preview');
    var embedCode = (deviation.extended &&
        deviation.extended.isEmbeddable &&
        deviation.extended.embedCode) ||
        undefined;
    return {
        url: getDeviationUrl(deviation),
        media: preview && preview.src,
        embedCode: embedCode,
    };
}
//# sourceMappingURL=helpers.js.map